var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hybrid-header-bar-wrapper"},[_c('GoBackArrow',{attrs:{"colorHex":"#353B3E"}}),_c('h1',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }